// Correlation only, never an authentication credential. Shared by this tab's
// session/game sockets; duplicated tabs replace the inherited instance's socket.
let instance: string | undefined;
export function clientInstance(): string {
  if (instance) return instance;
  try {
    const stored = sessionStorage.getItem("chessme.client-instance.v1");
    if (stored && /^[a-zA-Z0-9_-]{16,64}$/.test(stored)) return instance = stored;
  } catch { /* private storage may be disabled; keep this page's identity */ }
  instance = Array.from(crypto.getRandomValues(new Uint8Array(16)), b => b.toString(16).padStart(2, "0")).join("");
  try { sessionStorage.setItem("chessme.client-instance.v1", instance); } catch { /* in-memory fallback */ }
  return instance;
}

export function socketLimitMessage(code?: number): string | undefined {
  switch (code) {
    case 4001: return "This connection was opened in another tab. Reload here to reconnect.";
    case 4009: return "Two devices are already connected. Close one and reload this page.";
    case 4010: return "Live updates are busy. Direct game links still work.";
    case 4011: return "Game review connections are busy. Reload to reconnect.";
    default: return undefined;
  }
}
